import { AppService } from 'src/app/app.service';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Util } from 'src/app/helpers/utilities';
import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';
import { Constants } from 'src/app/helpers/messages';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
  
export class BaseComponent implements OnInit {

  authorizedMenu = Util.sidebarMenu

  isHandset$: Observable<boolean> = this.breakpointObserver.observe('(max-width: 900px)')
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
    
  menuSubHeader: string = '';
  picPreview: string;
  drawerOpen:boolean = false
  userDetails = this.app.helperService.getFromStore(Constants.LOGIN_USER)

  constructor(private breakpointObserver: BreakpointObserver, private app: AppService) {}
  logout(){
    this.app.logoutUser()
  }

  ngOnInit(): void {
    this.getProfilePic()
  }

  getProfilePic() {
    this.app.getPicture().subscribe(el=>{this.picPreview = el})    
  }

  allowAccess(accessRole){
    let userRole = this.app.helperService.getRoleList()
    for (let i = 0; i < userRole.length; i++) {
      for (let o = 0; o < accessRole.length; o++) {
        if(accessRole[o] == "Settings"){
          return true
        }

        if(userRole[i].name  ===  accessRole[o]){
          return true
        }
      }
    }
  }

  getInitials(string) {
    var names = string.split(' '),
    initials = names[0].substring(0, 1).toUpperCase();
    
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }

    return initials;
  };

}
